import { Controller } from "@hotwired/stimulus"

const GTAG_SCRIPT_HOST = "https://www.googletagmanager.com"

export default class extends Controller {
  static values = {
    propertyId: String,
    serverUrl: { type: String, default: "" },
    purchase: { type: Object, default: {} }
  }

  connect() {
    this.#loadGtagScript()

    window.dataLayer = window.dataLayer || []
    window.gtag = window.gtag || function() { window.dataLayer.push(arguments) }
    window.gtag("js", new Date())

    const config = { cookie_flags: "SameSite=None;Secure", linker: { accept_incoming: true } }

    if (this.serverUrlValue) {
      config.server_container_url = this.serverUrlValue
    }

    window.gtag("config", this.propertyIdValue, config)

    if (Object.keys(this.purchaseValue).length > 0) {
      window.gtag("event", "purchase", this.purchaseValue)
    }
  }

  #loadGtagScript() {
    const src = `${GTAG_SCRIPT_HOST}/gtag/js?id=${this.propertyIdValue}`
    if (document.querySelector(`script[src="${src}"]`)) return

    const script = document.createElement("script")
    script.async = true
    script.src = src
    document.head.appendChild(script)
  }
}
